var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.091 6.8L7.2 1.563 1.309 6.8a.863.863 0 01-1.072.026c-.304-.24-.317-.644-.03-.9L6.649.2A.833.833 0 017.2 0c.208 0 .408.072.551.2l6.442 5.727c.287.255.274.658-.03.9A.863.863 0 0113.09 6.8z","fillRule":"nonzero"}));
}

Chevron.defaultProps = {"width":"15","height":"7"};

module.exports = Chevron;

Chevron.default = Chevron;
